import { timeOptions } from 'data/timeOptions';
import { isEqual } from 'lodash';

export const getYesterday = () => {
  const today = new Date();

  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  return yesterday;
};

export const getDateAtStartOfTheDate = (date: Date | string) => {
  const tmpDate = new Date(date);

  const startOfDate = new Date(
    tmpDate.getFullYear(),
    tmpDate.getMonth(),
    tmpDate.getDate(),
  );

  return startOfDate;
};

export const getTimeOptionsAboveHour = (hour: number) =>
  timeOptions.filter(({ value }) => +value > hour);

export const getIsStartOfDayToday = (date: Date) =>
  isEqual(
    getDateAtStartOfTheDate(new Date()),
    getDateAtStartOfTheDate(new Date(date)),
  );
